
import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";
import { TestTube } from "lucide-react";

interface BillStatusFormProps {
  onSubmit: (values: { billComponentId: string, action: string }) => void;
  loading: boolean;
}

export function BillStatusForm({ onSubmit, loading }: BillStatusFormProps) {
  const billForm = useForm({
    defaultValues: {
      billComponentId: "",
      action: "paid"
    }
  });

  return (
    <Form {...billForm}>
      <form onSubmit={billForm.handleSubmit(onSubmit)} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField
            control={billForm.control}
            name="billComponentId"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Bill Component ID</FormLabel>
                <FormControl>
                  <Input 
                    placeholder="Enter bill component ID" 
                    {...field} 
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={billForm.control}
            name="action"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Action</FormLabel>
                <FormControl>
                  <select 
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
                    {...field}
                  >
                    <option value="paid">Mark as Paid</option>
                    <option value="cancel">Cancel Bill</option>
                  </select>
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        
        <Button 
          type="submit"
          disabled={loading}
          className="w-full md:w-auto"
        >
          {loading ? "Processing..." : "Test Bill Status Update"}
          <TestTube className="ml-2 h-4 w-4" />
        </Button>
      </form>
    </Form>
  );
}
